export const UPDATE_PRODUCT_CONFIG = 'UPDATE_PRODUCT_CONFIG'
export const RESET_PRODUCT_CONFIG = 'RESET_PRODUCT_CONFIG'
